class PhoneValidationController {
  constructor($mdDialog, $mdToast, PhoneValidation, user, number) {
    this.$mdDialog = $mdDialog;
    this.PhoneValidation = PhoneValidation;
    this.user = user;
    this.$mdToast = $mdToast;
    this.number = number;
  }
  close() {
    const { $mdDialog } = this;
    $mdDialog.hide();
  }
  sendValidationCode() {
    const { number, user, PhoneValidation } = this;
    this.sendingCode = true;
    PhoneValidation.sendCode({ user, number })
      .then(() => {
        this.sendingCode = false;
      })
      .catch((err) => {
        this.sendingCode = false;
      });
  }
  validate(code) {
    const {
      PhoneValidation, user, number, $mdToast,
    } = this;
    this.validatingCode = true;
    PhoneValidation.validateCode({ user, code, number })
      .then(() => {
        this.validatingCode = false;
        $mdToast.show($mdToast.simple().textContent('Validación Correcta'));
        this.close();
      })
      .catch((err) => {
        $mdToast.show($mdToast.simple().textContent(err.data.message));
        this.validatingCode = false;
      });
  }
}
PhoneValidationController.$inject = ['$mdDialog', '$mdToast', 'PhoneValidation', 'user', 'number'];
export default PhoneValidationController;

// 8977



// WEBPACK FOOTER //
// ./client/app/components/user/userDetails/phoneValidation/phoneValidation.controller.js